import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=176bdaf7&scoped=true&"
import script from "./AdminBar.vue?vue&type=script&lang=js&"
export * from "./AdminBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bdaf7",
  null
  
)

export default component.exports